var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.78872 0.955253C7.41168 0.332298 8.42169 0.332299 9.04464 0.955254C9.6676 1.57821 9.6676 2.58822 9.04464 3.21118L7.79573 4.46008C7.79537 4.46045 7.79501 4.46081 7.79464 4.46118C7.79428 4.46154 7.79391 4.46191 7.79355 4.46227L3.54202 8.71379C3.53503 8.72078 3.52811 8.72771 3.52124 8.73459C3.41921 8.83679 3.3292 8.92694 3.22225 8.99746C3.12823 9.05947 3.02625 9.10848 2.9191 9.14316C2.79722 9.18262 2.67059 9.19659 2.52704 9.21242C2.51738 9.21349 2.50765 9.21456 2.49784 9.21565L1.08768 9.37233C0.96188 9.38631 0.836545 9.34235 0.747042 9.25284C0.657538 9.16334 0.613573 9.038 0.627551 8.9122L0.784235 7.50205C0.785326 7.49223 0.786399 7.4825 0.787465 7.47284C0.803299 7.32929 0.817267 7.20266 0.856721 7.08078C0.89141 6.97363 0.940421 6.87166 1.00242 6.77763C1.07295 6.67069 1.1631 6.58068 1.2653 6.47864C1.27218 6.47177 1.27911 6.46485 1.2861 6.45787L6.78872 0.955253ZM5.83335 3.08914L1.87535 7.04712C1.74097 7.1815 1.71603 7.20923 1.69811 7.23639C1.67745 7.26773 1.66111 7.30173 1.64955 7.33744C1.63952 7.3684 1.63346 7.4052 1.61247 7.59408L1.5133 8.48658L2.40581 8.38741C2.59468 8.36643 2.63148 8.36036 2.66244 8.35034C2.69816 8.33878 2.73215 8.32244 2.76349 8.30177C2.79066 8.28386 2.81838 8.25891 2.95276 8.12454L6.91076 4.16655L5.83335 3.08914ZM7.50001 3.57729L6.4226 2.49988L7.37798 1.54451C7.67549 1.24699 8.15787 1.24699 8.45538 1.54451C8.7529 1.84203 8.7529 2.3244 8.45538 2.62192L7.50001 3.57729Z",
    fill: "#212529"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.b660294d5a620c34ebe515f28fd9a3ab.svg";
export { ForwardRef as ReactComponent };